import * as React from 'react';
import { IgcGridToolbarTitleComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Provides a way to template the title portion of the toolbar in the grid.
 * @class
 */
export const IgrGridToolbarTitle = /* @__PURE__ */ createComponent({
  tagName: 'igc-grid-toolbar-title',
  displayName: 'IgrGridToolbarTitle',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrGridToolbarTitle = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarTitleModule = Component;
